import { render, staticRenderFns } from "./SelectResource.vue?vue&type=template&id=22ccb866&scoped=true"
import script from "./SelectResource.vue?vue&type=script&lang=js"
export * from "./SelectResource.vue?vue&type=script&lang=js"
import style0 from "./SelectResource.vue?vue&type=style&index=0&id=22ccb866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ccb866",
  null
  
)

export default component.exports